<template>
  <div>
    <loading-spinner :visible="isLoading" />
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="pl-1 text-center">
        <div class="alert alert-success" role="alert">
          <b class="fs-4">상품별 페이지뷰 & 구매통계</b>
        </div>
        <div class="mb-3 col-4 d-flex" style="height: 50px;">
          <div style="width: 600px;">
            <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_catCode" v-model="this.catCode" @change="changeCatCode(catCode)">
              <option disabled>상품카테고리</option>
              <option :value="{ value: 'A', type: 'nVal'}">전체보기</option>
              <option :value="{ value: ac.baseCode, type: 'yVal' }" :key="i" v-for="(ac, i) in this.pdtCategoryList">{{ ac.codeNameKor }}</option>
              <option :value="{ value: 'VR', type: 'nVal'}">버라이어티팩</option>
              <option :value="{ value: 'BE', type: 'nVal'}">베스트</option>
              <!-- <option value="gr">그룹</option> -->
            </select>
          </div>

          <div class="input-group" style="height:30px;">
            <input type="month" class="form-control form-control-sm" style="width:100px; font-size: 0.8rem;" v-model="this.selMonth">
            <button type="button" class="btn btn-success btn-sm"  @click="searchByMonth(this.catCode, this.selMonth)">검색</button>
          </div>
        </div>

        <!-- 뷰&구매 통계 테이블 -->
        <div :key="i" v-for="(tc, i) in this.tableDataForCategory">
          <div style="text-align: start; font-weight: 600;">
            <label style="background-color: lightgray; width: 400px; padding: 5px; border-radius: 8px;">
              &nbsp;&nbsp;&nbsp;▷&nbsp;&nbsp;{{ tc.category }} ({{ tc.salesRoutes[0].route }}): 
              [ 뷰총계: <span class="text-primary">{{ getCategoryTotals(tc).totalViews }}</span> / 구매총계: <span class="text-danger">{{ getCategoryTotals(tc).totalPurchases }}</span> ]
            </label>
          </div>
          <table>
            <tbody>
              <tr class="fw-bold" style="background-color: rgb(240, 236, 236);">
                <td class="text-center" style="border: solid 1px;">/</td>
                <td v-for="(date, dateIndex) in daysInCurrentMonth" :key="dateIndex" class="text-center" style="border: solid 1px;">
                  {{ date.substring(5) }} <!-- 월일(MM-DD) 표시 -->
                </td>
              </tr>
              <tr v-for="(sr, si) in tc.salesRoutes" :key="si">
                <td class="text-center" style="border: solid 1px;">
                  <span class="text-primary">뷰</span>
                </td>
                <td v-for="(date, colIndex) in daysInCurrentMonth" :key="colIndex" class="text-center" style="border: solid 1px;">
                  <span v-if="sr.dates[date]" class="badge bg-primary">
                    <span v-if="sr.dates[date].views > 0">{{ sr.dates[date].views }}</span>
                  </span>
                  <span v-else></span>
                </td>
              </tr>
              <tr v-for="(sr, si) in tc.salesRoutes" :key="si">
                <td class="text-center" style="border: solid 1px;">
                  <span class="text-danger">구매</span>
                </td>
                <td v-for="(date, colIndex) in daysInCurrentMonth" :key="colIndex" class="text-center" style="border: solid 1px;">
                  <span v-if="sr.dates[date]" class="badge bg-danger">
                    <span v-if="sr.dates[date].purchases > 0 || sr.dates[date].purchases < 0">{{ sr.dates[date].purchases }}</span>
                  </span>
                  <span v-else></span>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- 상품별 반복: 동일 카테고리의 상품만 -->
          <div v-for="tp in tableDataForProduct.filter(t => t.category === tc.category)" :key="tp.category">
            <div v-for="product in tp.products" :key="product.product" style="text-align: start; margin-top: 10px; padding-left: 15px; font-size: .9rem;">
              <label style="padding: 5px; border-radius: 8px;">
                <span class="text-danger" v-if="product.curStatus == 'N'"><i class="bi bi-ban-fill"></i></span>
                <span v-else>▼</span>
                {{ product.productName}} ({{ product.productCode }})&nbsp;&nbsp;&nbsp;
                [ 뷰총계: <span class="text-info">{{ getProductTotals(product).totalViews }}</span>
                / 구매총계: <span class="text-warning">{{ getProductTotals(product).totalPurchases }}</span> ]&nbsp;
                <!-- <span class="text-danger" v-if="product.curStatus === 'N'">판매중지</span> -->
                <!-- <span class="text-danger">{{ product.curStatus }}</span> -->
              </label>
              <table>
                <tbody>
                  <tr style="background-color: beige;">
                    <td class="text-center" style="border: solid 1px;">/</td>
                    <td v-for="date in daysInCurrentMonth" :key="date" class="text-center" style="border: solid 1px;">
                      {{ date.substring(5) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center" style="border: solid 1px;"><span class="text-info">뷰</span></td>
                    <td v-for="date in daysInCurrentMonth" :key="date" class="text-center" style="border: solid 1px;">
                      <span v-if="product.dates[date]" class="badge bg-info" style="color: black;">
                        <span v-if="product.dates[date].views>0">{{ product.dates[date].views }}</span>
                      </span>
                      <span v-else></span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center" style="border: solid 1px;"><span class="text-warning">구매</span></td>
                    <td v-for="date in daysInCurrentMonth" :key="date" class="text-center" style="border: solid 1px;">
                      <span v-if="product.dates[date]" class="badge bg-warning" style="color: black;">
                        <span v-if="product.dates[date].purchases>0 || product.dates[date].purchases<0">{{ product.dates[date].purchases }}</span>
                      </span>
                      <span v-else></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <hr style="border: solid 5px green;" class="mt-5 mb-4">
        </div>

      </div>
    </main>
  </div>
</template>

<script>
import dayjs from "dayjs";
import LoadingSpinner from '../components/LoadingSpinner.vue';     // 로딩스피너 컴포넌트

export default {
  components: {
    LoadingSpinner
  },
  // DB에서 가져온 데이타
  data() {
    return {
      isLoading: false,                     // 로딩 스피너 표시 여부
      currentYear: dayjs().year(),          // 현재 연도
      currentMonth: dayjs().month() + 1,    // 현재 월 (0부터 시작하므로 +1)
      daysInCurrentMonth: [],               // 현재 월의 날짜 배열
      catCode: "",                        // 카테고리코드

      pdtCategoryList: [],                  //상품카테고리정보

      pViewByProduct: [],                   //상품별 페이지뷰정보
      pViewByProduct_org: [],               //상품별 페이지뷰정보-원본
      pViewByProduct_show: [],              //상품별 페이지뷰정보-표시용
      pViewByProduct_L: [],                 //상품별 페이지뷰정보_현지투어
      sRoute: "",                           //상품카테고리코드

      //pgView_bySalesRoute: {},              //상품별 페이지뷰정보_카테고리별
      tableDataForCategory: [],             //상품카테고리 매핑데이타
      tableDataForProduct: [],              //상품별 매핑데이타


      // tableData: [],                              //연계상품페이지용 매핑데이타
      // tableDataForLanding: [],                    //랜딩페이지용 매핑데이타

    };
  },
  created() {
    //this.productId = this.$route.query.productId;
    this.user = this.$store.state.user;

    this.getPdtCategoryList();                         //상품카테고리정보
    this.getPageviewByProduct();                       //상품별 페이지뷰정보
  }, 

  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }
    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";

    this.daysInMonth()
  },
  
  methods: {
    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    // 상품카테고리정보
    async getPdtCategoryList(){
      let pdtCategoryList = await this.$api("/api/pdt_categoryList", {});
      if(pdtCategoryList.length > 0)
      {
        //this.assoCodeList_org = pdtCategoryList
        this.pdtCategoryList = pdtCategoryList
      }
      // console.log("pdtCategoryList:::::::::", this.pdtCategoryList)
    },

    //카테고리 뷰/구매 총계
    getCategoryTotals(tc) {
      let totalViews = 0;
      let totalPurchases = 0;
      tc.salesRoutes.forEach(sr => {
        Object.values(sr.dates).forEach(d => {
          totalViews += d.views;
          totalPurchases += d.purchases;
        });
      });
      return { totalViews, totalPurchases };
    },


    // 상품별 뷰/구매 총계
    getProductTotals(product) {
      let totalViews = 0;
      let totalPurchases = 0;
      Object.values(product.dates).forEach(d => {
        totalViews += d.views;
        totalPurchases += d.purchases;
      });
      return { totalViews, totalPurchases };
    },

    // 카테고리별 검색(A,T,L,E,S,VR,BE)
    changeCatCode(catCode) {

      if(catCode.type == "nVal")      // A, VR, BE
      {
        if(catCode.value == "A")
        {
          this.pViewByProduct_show = this.pViewByProduct_org
        }
        else if(catCode.value == "VR")
        {
          this.pViewByProduct_show = this.pViewByProduct.filter(item => {
            return (item.vrFlag === 'Y')
          })
        }
        else if(catCode.value == "BE")
        {
          this.pViewByProduct_show = this.pViewByProduct.filter(item => {
            return (item.bestFlag === 'Y')
          })
        }
      }
      else if(catCode.type == "yVal") // catCode.value
      {
        this.pViewByProduct_show = this.pViewByProduct.filter(item => {
          return (item.salesRoute === catCode.value)
        })
      }
      this.transformData()
    },


    // 기한부 검색
    async searchByMonth(catCode, selMonth) {
      if (!selMonth || !catCode) {
        this.$swal.fire('', '조회조건(카테고리 또는 조회월)을 체크해주세요', 'warning');
        return;
      }

      this.isLoading = true; // 로딩 시작
      try
      {
        // 기초데이타 갱신
        let params = {
          catCode: catCode.value,
          selMonth: selMonth
        };
        let pViewByProduct = await this.$api("/api/pViewByProduct", params);

        if (pViewByProduct.length <= 0) 
        {
          this.$swal.fire('', '조회된 데이터가 없습니다.', 'warning');
          return false;
        } 
        else 
        {
          this.pViewByProduct_org = pViewByProduct;
          this.pViewByProduct = pViewByProduct;
          this.pViewByProduct_show = pViewByProduct;

          if(catCode.value == "A")
          {
            this.pViewByProduct_show = this.pViewByProduct_org.filter(item => {
              return (item.vDateKST.split('T')[0].startsWith(selMonth))
            })
          }
          else
          {
            this.pViewByProduct_show = this.pViewByProduct.filter(item => {
              return (item.salesRoute === catCode.value && item.vDateKST.split('T')[0].startsWith(selMonth))
            })
          }

          if(this.pViewByProduct_show.length <= 0)
          {
            this.$swal.fire('', '조회된 데이터가 없습니다.', 'warning');
            return false;
          }
          else
          {
            // 추출데이타 원본
            this.pViewByProduct_org = this.pViewByProduct_show
          }
        }
        this.daysInMonth();
        this.transformData();
      }

      finally
      {
        this.isLoading = false; // 로딩 종료
      }

      // // 기초데이타 갱신
      // let params = {
      //   catCode: catCode.value,
      //   selMonth: selMonth
      // };
      // let pViewByProduct = await this.$api("/api/pViewByProduct", params);

      // if (pViewByProduct.length <= 0) 
      // {
      //   this.$swal.fire('', '조회된 데이터가 없습니다.', 'warning');
      //   return false;
      // } 
      // else 
      // {
      //   this.pViewByProduct_org = pViewByProduct;
      //   this.pViewByProduct = pViewByProduct;
      //   this.pViewByProduct_show = pViewByProduct;

      //   if(catCode.value == "A")
      //   {
      //     this.pViewByProduct_show = this.pViewByProduct_org.filter(item => {
      //       return (item.vDateKST.split('T')[0].startsWith(selMonth))
      //     })
      //   }
      //   else
      //   {
      //     this.pViewByProduct_show = this.pViewByProduct.filter(item => {
      //       return (item.salesRoute === catCode.value && item.vDateKST.split('T')[0].startsWith(selMonth))
      //     })
      //   }

      //   if(this.pViewByProduct_show.length <= 0)
      //   {
      //     this.$swal.fire('', '조회된 데이터가 없습니다.', 'warning');
      //     return false;
      //   }
      //   else
      //   {
      //     // 추출데이타 원본
      //     this.pViewByProduct_org = this.pViewByProduct_show
      //   }
      // }
      // this.daysInMonth();
      // this.transformData();
    },

    // 상품별 페이지뷰 정보
    async getPageviewByProduct(){
      let pViewByProduct = await this.$api("/api/pViewByProduct", {});
      
      if(pViewByProduct.length <= 0)
      {
        this.$swal.fire('', '조회된 데이터가 없습니다.', 'warning');
        return false;
      }
      else
      {
        // 추출데이타 원본
        this.pViewByProduct_org = pViewByProduct

        // 페이지뷰용 상품정보
        this.pViewByProduct = pViewByProduct


        // 현지투어 상품정보
        this.pViewByProduct_L = pViewByProduct.filter(item => {
          return (item.salesRoute === 'L')
        })

        this.pViewByProduct_show = pViewByProduct
      }

      this.transformData()
    },


    // 데이타를 매핑용으로 변환
    transformData() {
      const groupedDataByCategory = {};             // 카테고리별로 그룹화된 데이터 객체생성
      const groupedDataByProduct = {};              // 동일카테고리 상품별로 그룹화된 데이터 객체생성

      // 데이터를 카테고리와 날짜별로 그룹화
      this.pViewByProduct_show.forEach((item) => {
        let category = item.catName;             // 카테고리 이름
        let salesRoute = item.salesRoute;        // 판매 경로
        let date = item.vDateKST.split('T')[0];  // YYYY-MM-DD 형식

        // 1.카테고리그룹생성
        if (!groupedDataByCategory[category]) {
          groupedDataByCategory[category] = {};
        }

        // 2.카테고리코드그룹생성
        if (!groupedDataByCategory[category][salesRoute]) {
          groupedDataByCategory[category][salesRoute] = {};
        }

        // 3.날짜그룹생성
        if (!groupedDataByCategory[category][salesRoute][date]) {
          groupedDataByCategory[category][salesRoute][date] = {
            views: 0,
            purchases: 0,
            salesRoutes: {}, // 카테고리별 데이타객체생성
          };
        }

        // 4.날짜별로 조회수와 구매수 합산
        groupedDataByCategory[category][salesRoute][date].views += item.countViews;
        groupedDataByCategory[category][salesRoute][date].purchases += item.countPurchases;

        // 5.판매 경로별[salesRoute] 데이터 추가
        if (!groupedDataByCategory[category][salesRoute][date].salesRoutes[salesRoute]) {
          groupedDataByCategory[category][salesRoute][date].salesRoutes[salesRoute] = {
            views: 0,
            purchases: 0,
          };
        }
        // 6.누적계산
        groupedDataByCategory[category][salesRoute][date].salesRoutes[salesRoute].views += item.countViews;
        groupedDataByCategory[category][salesRoute][date].salesRoutes[salesRoute].purchases += item.countPurchases;
      });

      //console.log("groupedDataByCategory:", groupedDataByCategory)

      // 7. 테이블 데이터 변환 (객체의 키를 이용하여 객체를 순회하되, dates는 객체로 변환)
      this.tableDataForCategory = Object.keys(groupedDataByCategory).map((category) => ({
        category,
        salesRoutes: Object.keys(groupedDataByCategory[category]).map((route) => ({
          route,
          dates: Object.fromEntries(                                                    //객체로 변환하는 함수
            Object.keys(groupedDataByCategory[category][route]).map((date) => [
              date,
              { date, ...groupedDataByCategory[category][route][date] }
            ])
          )
        }))
      }))

      // 데이터를 동일 카테고리하의 상품별로 그룹화
      this.pViewByProduct_show.forEach((item) => {
        let category = item.catName;             // 카테고리 이름
        let date = item.vDateKST.split('T')[0];  // YYYY-MM-DD 형식
        let pdtCode = item.pdtCode;              // 상품코드
        let pdtNameKor = item.pdtNameKor;        // 상품명
        let curStatus = item.curStatus;          // 판매상태


        // 1.카테고리그룹생성
        if (!groupedDataByProduct[category]) {
          groupedDataByProduct[category] = {};
        }

        // 2.동일 카테고리 하의 상품그룹생성
        if (!groupedDataByProduct[category][pdtCode]) {
          groupedDataByProduct[category][pdtCode] = {
            curStatus: curStatus
          };
        }

        // 3.날짜그룹생성
        if (!groupedDataByProduct[category][pdtCode][date]) {
          groupedDataByProduct[category][pdtCode][date] = {
            pdtNameKor: pdtNameKor,
            views: 0,
            purchases: 0,
            products: {}, // 상품별별 데이타객체생성
          };
        }

        // 4.날짜별로 조회수와 구매수 합산
        groupedDataByProduct[category][pdtCode][date].views += item.countViews;
        groupedDataByProduct[category][pdtCode][date].purchases += item.countPurchases;

        // 5.판매 경로별[salesRoute] 데이터 추가
        if (!groupedDataByProduct[category][pdtCode][date].products[pdtCode]) {
          groupedDataByProduct[category][pdtCode][date].products[pdtCode] = {
            views: 0,
            purchases: 0,
          };
        }
        // 6.누적계산
        groupedDataByProduct[category][pdtCode][date].products[pdtCode].views += item.countViews;
        groupedDataByProduct[category][pdtCode][date].products[pdtCode].purchases += item.countPurchases;
      });

      //console.log("groupedDataByCategory:", groupedDataByCategory)

      this.tableDataForProduct = Object.keys(groupedDataByProduct).map((category) => ({
        category,
        products: Object.keys(groupedDataByProduct[category]).map((productCode) => {
          //날짜키와 혼동되지 않도록 날짜키만 필터링
          const firstDateKey = Object.keys(groupedDataByProduct[category][productCode]).filter(key => key !== 'curStatus')[0];
          const firstDateData = groupedDataByProduct[category][productCode][firstDateKey];
          return {
            productCode,
            productName: firstDateData.pdtNameKor,
            curStatus: groupedDataByProduct[category][productCode].curStatus, // 여기서 추출
            dates: Object.fromEntries(
              Object.keys(groupedDataByProduct[category][productCode])
                .filter(dateKey => dateKey !== 'curStatus')
                .map((date) => [
                  date,
                  { date, ...groupedDataByProduct[category][productCode][date] }
                ])
            )
          };
        })
      }));
      //console.log("tableDataForProduct:::::::::::::::::::", this.tableDataForProduct);      
    },

    // 페이지뷰 통계표
    daysInMonth() {
      const days = [];

      let year = this.currentYear;
      let month = this.currentMonth;

      if (this.selMonth && this.selMonth !== "" && this.selMonth != undefined) {
        year = this.selMonth.split("-")[0];
        month = this.selMonth.split("-")[1];
      }

      const daysInCurrentMonth = dayjs(`${year}-${month}-01`).daysInMonth();

      for (let i = 1; i <= daysInCurrentMonth; i++) {
        days.push(dayjs(`${year}-${month}-${i}`).format("YYYY-MM-DD"));
      }

      this.daysInCurrentMonth = days; // Vue 데이터 속성에 저장

      //console.log("Generated days in month:", this.daysInCurrentMonth); // 디버깅용
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    // goToLink(type, link, asso){
    //   // console.log("link:", link, "asso:", asso, "type:", type)
    //   let url = ""
    //   if(type=="lp" && link == 'lj')
    //   {
    //     // let route = this.$router.push({path: '/bustour_asso', query: {assoFlag: link}});
    //     url = this.$router.resolve({path: '/bustour_asso', query: {assoFlag: link}});
    //   }
    //   else if(type=="lp" && link != 'lj')
    //   {
    //     // let route = this.$router.push({path: '/bustour_asso', query: {assoFlag: link}});
    //     url = this.$router.resolve({path: '/bustour_asso_gen', query: {assoFlag: link}});
    //   }      
    //   else if(type == "pd")
    //   {
    //     // let route = this.$router.push({path: '/productDetail_asso', query: {productId: link, salesRoute: "L", asso: asso}});
    //     url = this.$router.resolve({path: '/productDetail_asso', query: {productId: link, salesRoute: "L", asso: asso}});
    //   }

    //   //새창에 전개
    //   window.open(url.href, '_blank');
    // },
  }
}
</script>

<style scoped>
 /* input의 폭을 td에 맞춤 */
  input {
    width: 100%;
    box-sizing: border-box;
  }
</style>